import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/clientActions';
import {Link} from 'react-router-dom';

const ClientItem = ({client, actions}) => {
    const {setClientReducerProps} = actions;
    const {id, name, slug} = client;

    return (
      <tr>
        <td>{name}</td>
        <td>{slug}</td>
        <td>
          <Link className="btn btn-default" to={`/clients/${id}`}>Edit</Link>
        </td>
        <td>
          <span className="btn btn-danger" onClick={() => setClientReducerProps({deleteClientId: id})}>
            Delete
          </span>
        </td>
      </tr>
    );
};

ClientItem.propTypes = {
  id: PropTypes.number.isRequired,
  client: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  return {
    client: state.clientReducer[props.id],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientItem);
